import { render, staticRenderFns } from "./popup-table.vue?vue&type=template&id=a78f15e8"
import script from "./popup-table.vue?vue&type=script&lang=js"
export * from "./popup-table.vue?vue&type=script&lang=js"
import style0 from "./popup-table.vue?vue&type=style&index=0&id=a78f15e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports